import UserWinLossPage from "./user-win-loss-page";

export default UserWinLossPage;
